
var _learnq = _learnq || [];
  var classname = document.getElementsByClassName("btn btn--full add-to-cart");
var addToCart = function() {
_learnq.push(['track', 'Added to Cart', item]);
}; for (var i = 0; i < classname.length; i++) {
classname[i].addEventListener('click', addToCart, false);
}



//script for sticky header and announcement bar
function sticky_nav() {
  let lastScrollPosition = window.pageYOffset,
    announcement = document.querySelector('.announcement'),
    site_header = document.querySelector('.site-header'),
    offsetHeight = announcement.offsetHeight;
     
    if (window.screen.width >= 900 ){
      site_header.style.top = offsetHeight + "px"; 
      site_header.style.display = "block"; 
    }

window.addEventListener('scroll', function() {
  let currentScrollPosition = window.pageYOffset,
  template_product = document.querySelector('.template-product'),
  position_btn_atc;

  if(template_product){
    position_btn_atc = document.querySelector('.product-section .add-to-cart').offsetTop;
  }

  if (currentScrollPosition > lastScrollPosition) {
    // El usuario se está desplazando hacia abajo
    console.log('Desplazamiento hacia abajo', offsetHeight);
    announcement.classList.add('sticky_announce') ; 
  
      site_header.style.display= "none";
      if(template_product){
        if (window.pageYOffset >= position_btn_atc){
          show_sticky_atc();
        }
      }
      
     
  } else {
    // El usuario se está desplazando hacia arriba
    console.log('Desplazamiento hacia arriba', offsetHeight);
      site_header.classList.add('sticky_header_nav');
      site_header.style.top = offsetHeight + "px"; 
      site_header.style.display= "block";

      if(template_product){
        if (window.pageYOffset < position_btn_atc){
          hide_sticky_atc();
        }
      }
  }
  if (window.pageYOffset <= 0){
      announcement.classList.remove('sticky_announce') ;
      site_header.classList.remove('sticky_header_nav');
      
      if (window.screen.width >= 768 ) {
        site_header.style.top = offsetHeight + "px";
        site_header.style.display = "block"; 
      }else{
        site_header.style.top = 0;
        site_header.style.display = "block"; 
      }
  }
  
  lastScrollPosition = currentScrollPosition;
});

}
sticky_nav();

window.addEventListener('resize', function(event) {
  sticky_nav();
}, true);

//script for listening to PDP sticky ATC inputs change

if(document.querySelector(".options_contains_sticky fieldset")){
  const selectElement = document.querySelector(".options_contains_sticky fieldset");

  selectElement.addEventListener("change", (event) => {
    
    let price_variant = event.target.dataset.priceVariant,
    sticky_price = document.querySelector('.sticky_atc_price');
    sticky_price.innerHTML = price_variant;
  })
}


//script ATC sticky

document.addEventListener('click', function (e) {
  if(e.target.classList.contains('atc_sticky_btn') ){
    let variant_selected,
    formData = {};

    if(document.querySelector('.variant_container_p')){
      variant_selected = document.querySelector('.variant_container_p input:checked').dataset.variantId;
    }else{
      variant_selected = document.querySelector('.sticky_atc_product').dataset.variantId;
    }
    
    formData = {
      'items': [{
       'id': variant_selected,
       'quantity': 1
       }]
     };
     
     fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'dataType': 'json'
      },
      body: JSON.stringify(formData),
      })
      .then(response => response.json())
      .then(data => {
        location.href = "/cart";
          
      })
      .catch((error) => {
          console.error('Error:', error);
      });
 

  }
});

function show_sticky_atc() {
  
  if(document.querySelector('.sticky_atc__container')){
    let sticky = document.querySelector('.sticky_atc__container');
    if(sticky.classList.contains('hide_sticky')){ 
      sticky.classList.remove('hide_sticky');
    }
  }
}
function hide_sticky_atc() {
  
  if(document.querySelector('.sticky_atc__container')){
    let sticky = document.querySelector('.sticky_atc__container');
    if(!sticky.classList.contains('hide_sticky')){ 
      sticky.classList.add('hide_sticky');
    }
  }
}


//script ATC on PLP

function atc_plp(product_selected) {
  let  formData = {
    'items': [{
     'id': product_selected,
     'quantity': 1
     }]
   };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
        'Content-Type': 'application/json',
        'dataType': 'json'
    },
    body: JSON.stringify(formData),
    })
    .then(response => response.json())
    .then(data => {
      location.href = "/cart";
        
    })
    .catch((error) => {
        console.error('Error:', error);
    });
}

document.addEventListener('click', function (e) {

  if (e.target.classList.contains('variant_button_atc')) {

    let variant_selec = e.target.dataset.variantId;
    atc_plp(variant_selec);
    
  }else if(e.target.classList.contains('atc_direct')){

    let selected_direct = e.target.dataset.variantId;
    atc_plp(selected_direct);
  }else if(e.target.classList.contains('atc_width_variant')){
      let variants = e.target.previousElementSibling,
      buton_atc = e.target;

      variants.classList.toggle('hide_elements_atc');
      buton_atc.classList.toggle('hide_elements_atc');
  }
})
